import script from "./AssetProcessingTechniquePropertyEditForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetProcessingTechniquePropertyEditForm.vue?vue&type=script&setup=true&lang=ts"

import "./AssetProcessingTechniquePropertyEditForm.vue?vue&type=style&index=0&id=5781aac7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5781aac7"]])

export default __exports__